<template>
  <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition" scrollable>

    <v-card tile>
      <div style="height: 45px">
        <v-toolbar flat dark color="#042333">
          <v-btn icon @click="fecharDialog()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Separação de produtos para filial CD</v-toolbar-title>

          <v-spacer />

          <p class="subtitle-1 pt-5">
            PRODUTO: {{ `${produto.idproduto} - ${produto.descricao_produto}` }}
          </p>
        </v-toolbar>
      </div>

      <v-card-text class="pa-0 pt-5">
        <v-data-table
          :items="filiaisCD"
          :headers="headers"
          height="calc(100vh - 168px)"
          :loading="loading"
        >
          <template #progress>
            <v-progress-linear indeterminate rounded color="red" height="3" />
          </template>

          <template #top>
            <v-toolbar flat color="white" height="50px" class="pt-2">
              <p class="subtitle-1">
                <v-icon left>mdi-format-list-bulleted</v-icon>
                Listagem de Filiais do tipo CD
              </p>

              <v-spacer />

              <p :class="{'text-red': estoqueSeparadoRealTime > estoqueDisponivelParaCD}">
                Qtde. Total disponível:
                {{ Helpers.formatarValor(estoqueDisponivelParaCD) }}
              </p>

              <p class="pl-10">
                Qtde. Separada:
                {{ Helpers.formatarValor(estoqueSeparadoRealTime) }}
              </p>

              <p class="pl-10">
                Qtde. disponível para separação:
                {{ Helpers.formatarValor(Math.max(estoqueDisponivelParaCD - estoqueSeparadoRealTime, 0)) }}
              </p>
            </v-toolbar>
          </template>

          <template #item.filial_origem>
            {{ produto.filial }}
          </template>

          <template #item.qtdeSeparacao="{item}">
            <div class="w-max-130">
              <sys-input-formatador
                v-model="item.qtdeSeparacao"
                remover-valor-irrelevante
                class="input-regular"
                :max-digitos="4"
                centralizar
                @focus="$event.target.select()"
                @keydown.enter="addCarrinho(item)"
              />
            </div>
          </template>

          <template #item.action="{item}">
            <v-btn
              icon
              @click="addCarrinho(item)"
              :disabled="!QTDE_VALIDA(item) || estoqueSeparadoRealTime > estoqueDisponivelParaCD"
            >
              <v-icon>mdi-forklift</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import SysInputFormatador from '../../../utils/InputFormatadorDeValor'
import Mixin from './../MixinDRP'
import DrpAPI from "../../../../api/drp";

export default {
  name: "dialogSeparacao",
  components: { SysInputFormatador },
  model: {
    prop: 'dialog',
    event: 'change-dialog'
  },
  props: {
    dialog: {
      type: Boolean,
      required: true
    },
    produto: {
      type: Object,
      required: true
    },
    filiais: {
      type: Array,
      required: true
    },
    pedido: {
      type: Object,
      required: false
    }
  },
  mixins: [Mixin],
  data: () => ({
    separacaoAtualDoProduto: [],
    filiaisCD: [],
    headers: [
      { text: "Filial Origem", value: "filial_origem", align: "center", width: '30%' },
      { text: "Filial Destino", value: "filial", align: "center", width: '30%' },
      { text: "Quantidade Separação", value: "qtdeSeparacao" },
      { text: "Ações", value: "action", align: "center", width: '80px' }
    ],
    SOMA_QTDE: (novo, atual) => parseFloat(novo) + parseFloat(atual),
    QTDE_VALIDA: (item) => item.qtdeSeparacao && parseFloat(item.qtdeSeparacao) > 0
  }),
  computed: {
    estoqueDisponivelParaCD () {
      const {estoque_disp_distribuicao} = this.produto

      return parseFloat(estoque_disp_distribuicao)
    },
    qtdeAtualmenteSeparadaNoCarrinho () {
      return this.Helpers
        .arrayColumn(this.separacaoAtualDoProduto, 'qtde_pedido')
        .reduce(this.SOMA_QTDE, 0)
    },
    estoqueSeparadoRealTime () {
      const SOMA_TOTAL = this.Helpers
        .arrayColumn(this.filiaisCD, 'qtdeSeparacao')
        .reduce(this.SOMA_QTDE, this.qtdeAtualmenteSeparadaNoCarrinho)

      return parseFloat(SOMA_TOTAL ? SOMA_TOTAL : this.qtdeAtualmenteSeparadaNoCarrinho)
    }
  },
  watch: {
    dialog () {
      if (this.dialog) {
        this.verificarSeparacaoAtualDoProduto()
      }
    }
  },
  methods: {
    setFiliaisAindaPorSeparar () {
      this.filiaisCD = []

      const FILIAIS_JA_SEPARADAS = this.Helpers.arrayColumn(this.separacaoAtualDoProduto, 'filial_destino');

      this.filiais.forEach(filial => {
        if (!FILIAIS_JA_SEPARADAS.includes(filial.filial)) {
          const novaFilial = Object.assign({}, filial)
          novaFilial.qtdeSeparacao = 0

          this.filiaisCD.push(novaFilial)
        }
      })
    },
    verificarSeparacaoAtualDoProduto () {
      const headers = this.Helpers.iniciarRequisicao()

      const params = {
        filialOrigem: this.produto.filial,
        idproduto: this.produto.idproduto
      }

      this.$store.dispatch(
        "loading/addRequisicao",
        DrpAPI.verificarSeparacaoAtualDoProduto(headers, params)
          .then((response) => {
            const { token, produto } = response.data
            localStorage.setItem("token", token)
            this.separacaoAtualDoProduto = produto
            this.setFiliaisAindaPorSeparar()
          })
          .catch(() => {
            this.Helpers.logout()
          })
      )
    },
    fecharDialog () {
      this.$emit('change-dialog', false)
    },
    async addCarrinho (item) {
      this.loading = ! this.loading

      const { filial: filialOrigem, idproduto } = this.produto

      const { filial: filialDestino, qtdeSeparacao } = item

      const itemSeparacao = {
        idpedido: this.pedido.idpedido,
        idproduto,
        filialOrigem,
        filialDestino,
        qtdeSeparacao
      }

      const resultado = await this.adicionarProdutoNoCarrinho(itemSeparacao)

      if (resultado) {
        this.loading = ! this.loading

        this.filiaisCD = this.filiaisCD.filter(filial => filial.filial != item.filial)

        this.filiaisCD.length === 0 && this.fecharDialog()

        this.separacaoAtualDoProduto.push({
          idproduto,
          filial_destino: filialDestino,
          qtde_pedido: qtdeSeparacao
        })

        this.$emit('produto-add-com-sucesso')
      }
    }
  }
}
</script>

<style scoped>

</style>
